import pharmacyDelivery from 'assets/pharmacy-delivery.svg';
import pharmacyDirectDelivery from 'assets/pharmacy-direct-delivery.svg';
import royalMailDelivery from 'assets/royal-mail-delivery.svg';

const AddMedicationPageContent = {
  headingText: 'Add medication',
  infoBoxText: 'Your GP will check all medication to make sure it matches your prescription',
};

const AddMedicationSelectPageContent = {
  headingText: 'Add medication',
  infoBoxText: 'This must match what is on your prescription',
  changeMedicationText: 'Change medication',
  changeFormText: 'Change form',
  formHeadingText: 'Form',
  formErrorText: 'Select form',
  strengthHeadingText: 'Strength',
  strengthErrorText: 'Select strength',
  nextButtonText: 'Next',
  addButtonText: 'Add medication',
};

const AddMedicationFormContent = {
  headingText: 'Select medication',
  searchLabelText: 'Search by medication name',
  noResultsHeader: 'No results found',
  noResultsInfo1: 'Check your spelling',
  noResultsInfo2: 'Check the name on your prescription',
  noResultsInfo3: 'Contact your GP to confirm your medication',
  noResultsText:
    'Still having trouble searching your medication? <a style="color: #282828;" href="https://intercom-help.eu/heypharmacist/en" target="_blank">Contact us</a>',
};

const RegisterPageContent = {
  headingText: 'Now, register with NHS login',
  infoHeadingText: 'We’re partnering with the NHS',
  isP9: {
    infoText1: 'faster GP approval',
    infoText2: 'automatically see your up-to-date prescription',
    infoText3: 'order and access more features on our app',
  },
  isP5: {
    infoText1: 'Go to NHS login to create your secure account with Hey Pharmacist.',
  },
  nhsRegisterText: 'Register using NHS login',
  loadingRedirectText: 'You are now being redirected to NHS login',
  externalLinksHTML:
    'By continuing, you are agreeing to Hey Pharmacist&#700;s <a href="https://www.heypharmacist.co.uk/privacypolicy" target="_blank">Privacy Policy</a> and <a href="https://heypharmacist.co.uk/terms-and-conditions" target="_blank">Terms and Conditions</a>.',
};

const ConsentPageContent = {
  headingText: 'All set. Welcome to Hey Pharmacist.',
  subeadingText1: 'You can now add your medication and place your first order.',
  subHeadingText2: 'We’ll send you emails about your orders and essential service updates to ',
  subHeadingTextP5: 'You can now add your medication and place your first order.',
  subHeadingTextP9:
    'You are now signed in to Hey Pharmacist and can begin ordering your medication.<br/><br/>We’ll send you emails about your orders and essentials service updates to ',
  infoHeadingText: 'Stay up-to-date with Hey Pharmacist',
  consentText1: 'Allow us to contact you about your experience of using the service',
  consentText2: 'Get email updates with expert health advice and offers',
  continueButtonText: 'Continue',
  externalLinksHTML:
    'By choosing continue, you agree to our <a href="https://heypharmacist.co.uk/terms-and-conditions" target="_blank">Terms & Conditions</a> and <a href="https://www.heypharmacist.co.uk/privacypolicy" target="_blank">Privacy Policy</a>.',
};

const EmailPreferencePageContent = {
  headingText: 'Email preferences',
  subHeadingText1: 'Your use of the app',
  paragraphText1:
    'Allow us to contact you about your experiences of using the website. This will help us make it better.',
  tickBoxText1: 'Emails about your use of the website',

  subHeadingText2: 'Marketing email',
  paragraphText2: 'Monthly updates from Hey Pharmacist, including health advice and offers.',
  tickBoxText2: 'Marketing emails',

  endingText:
    'You can change your mind at any time.<br/><br/>Find out more about <a style="font-weight:500;" href="https://www.heypharmacist.co.uk/privacypolicy" target="_blank">how we use your personal data</a>',

  submitButtonText: 'Save',
};

const RegisterContinuePageContent = {
  headingText: 'Continue NHS login',
  subHeadingText:
    'After registering the NHS will review your account within 2 hours. They will send you a confirmation email.',
  infoHeadingText: 'When you have received confirmation, you can:',
  infoText1: 'sign in to Hey Pharmacist with your NHS Login',
  infoText2: 'order your medication online',
  infoText3: 'choose where to have your prescription delivered',
  contactPreText: 'Still awaiting approval?',
  contactLinkText: 'Contact us',
  email: 'help@heypharmacist.co.uk',
};

const LoginPageContent = {
  headingText: 'Sign in',
  subHeadingText:
    'If you’ve registered with NHS login, please use your NHS login details to sign in to Hey Pharmacist.',
  subHeadingText2: 'Or sign in with Hey Pharmacist.',
  hpSignInButton: 'Sign in with Hey Pharmacist',
  registerPreText: 'Don’t have an account?',
  registerLinkText: 'Register',
};

const LoginEmailPageContent = {
  headingText: 'Sign in with Hey Pharmacist',
  mobilePreText: 'Or',
  mobileLinkText: 'sign in with your mobile number',
  linkageKeyPreText: 'Registered with linkage keys?',
  linkageKeyLinkText: 'Sign in on the app',
  linkageKeyMissingText:
    'This method of signing in is not currently available online (coming soon), but you can sign into the Hey Pharmacist mobile app this way. For information on how to download our app visit <a style="font-weight:500;" href="https://heypharmacist.co.uk/mobile-app" target="_blank" rel="noopener noreferrer">this page</a>',
  linkageKeyMissingTextRegister:
    'This method of registering is not currently available online (coming soon), but you can sign into the Hey Pharmacist mobile app this way. For information on how to download our app visit <a style="font-weight:500;" href="https://heypharmacist.co.uk/mobile-app" target="_blank" rel="noopener noreferrer">this page</a>',
  registerPreText: 'Don’t have an account?',
  registerLinkText: 'Register',
};

const LoginMobilePageContent = {
  headingText: 'Sign in with Hey Pharmacist',
  emailPreText: 'Or',
  emailLinkText: 'sign in with your email address',
  linkageKeyPreText: 'Registered with linkage keys?',
  linkageKeyLinkText: 'Sign in on the app',
  linkageKeyMissingText:
    'This method of signing in is not currently available online (coming soon), but you can sign into the Hey Pharmacist mobile app this way. For information on how to download our app visit <a style="font-weight:500;" href="https://heypharmacist.co.uk/mobile-app" target="_blank" rel="noopener noreferrer">this page</a>',
  linkageKeyMissingTextRegister:
    'This method of registering is not currently available online (coming soon), but you can sign into the Hey Pharmacist mobile app this way. For information on how to download our app visit <a style="font-weight:500;" href="https://heypharmacist.co.uk/mobile-app" target="_blank" rel="noopener noreferrer">this page</a>',
  registerPreText: 'Don’t have an account?',
  registerLinkText: 'Register',
};

const SignInMobileFormContent = {
  signinLabel: 'Enter your mobile number',
  signinButton: 'Continue',
  verifyLabel: "To check we've got the right mobile number, we've sent you a 6 digit code to ",
  verifyButton: 'Continue',
};

const SignInEmailFormContent = {
  signinLabel: 'Enter your email address',
  signinButton: 'Continue',
  verifyLabel: "To check we've got the right email address, we've sent you a 6 digit code to ",
  verifyButton: 'Continue',
};

const DeliveryOptionPageContent = {
  headingText: 'Collection or delivery',
  homeDelivery: {
    title: 'Postage via Royal Mail',
    points: ['Dispensed by Rowlands Pharmacy Online', 'Plain, protective packaging', 'Free delivery to any UK address'],
    image: { src: royalMailDelivery, alt: 'Royal Mail Delivery' },
  },
  collectFromPharmacy: {
    title: 'Pharmacy Collection',
    points: ['Collect from your local pharmacy', 'Faster and free', 'Face-to-face health advice'],
    image: { src: pharmacyDelivery, alt: 'Collect From Pharmacy' },
  },
  pharmacyDelivery: {
    title: 'Pharmacy Delivery',
    points: ['Delivered from your local pharmacy', 'Secure in-person delivery', 'Free delivery direct to your door'],
    image: { src: pharmacyDirectDelivery, alt: 'Pharmacy Delivery' },
  },
  warningMessage: {
    fridgeline: {
      heading: 'Collection advised',
      text: 'Your order includes an item that needs to be kept refrigerated, we highly recommend you collect from your local pharmacy',
    },
    controlled: {
      heading: 'Collection advised',
      text: 'Your order includes controlled medication which needs to be securely handled. We suggest you order for collection from your local pharmacy.',
    },
    offboarding: {
      heading: 'Select a new method',
      text: 'Sorry, your previously selected pharmacy, {pharmacyName}, is no longer available on Hey Pharmacist. Please select a new method below.',
    },
  },
};

const DeliveryDetailsPageContent = {
  headingText: 'Delivery details',
  introText: 'When your order is approved, we can send to any UK address.',
  addressLoadingText: 'Loading your addresses',
  addAddressText: 'Add address',
  continueButtonText: 'Next',
  pharmacyDeliveryOverlayHeader: 'Sorry, pharmacy delivery isn’t available to your selected address',
  pharmacyDeliveryOverlayText:
    'Your selected address is outside of your pharmacies delivery radius. Would you like to select another method or revert to your previous postcode?',
  selectedPharmacyDeliveryOverlayOption1: 'Continue with Collection',
  pharmacyDeliveryOverlayOption1: 'Select another method',
  pharmacyDeliveryOverlayOption2: 'Change back to ',
};

const PharmacyDeliveryPageContent = {
  headingText: 'Select a pharmacy',
};

const PaymentMethodPageContent = {
  headingText: 'Payment method',
  introText: 'Select a payment method',
  introTextAccount: 'Review your payment methods',
  cardLoadingText: 'Loading your payment methods',
  addCardText: 'Add a payment',
  editCardText: 'Edit',
  doneEditingCardText: 'Done',
  deletedCardMessageText: 'Payment card deleted',
};

const ErrorPageContent = {
  headingText: 'Sorry, something went wrong…',
  paymentDeclinedErrorText: 'Your payment was declined, please select another card',
  genericErrorText: 'Please try your request again',
  retryButtonText: 'Try again',
  email: 'help@heypharmacist.co.uk',
  extraErrorText1:
    'If you’ve not been able to place an order then you can <a style="font-weight:500;" href="https://intercom-help.eu/heypharmacist/en" target="_blank">contact our support team here</a>. ',
  extraErrorText2: 'Or please come back another time and ',
  extraErrorTextLink: 'start again',
  extraErrorText3: '.',
};

const LogoutPageContent = {
  headingText: 'You’ve been signed out',
  subHeadingText: 'Sign in to continue.',
  loginButtonText: 'Sign in',
  contactLinkText: 'Contact us',
  email: 'help@heypharmacist.co.uk',
};

const RedirectPageContent = {
  spinner: 'Welcome back to Hey Pharmacist',
};

const BasketBarContent = {
  countText: 'selected',
  buttonText: 'Request Medication',
};

const BasketPageBarContent = {
  headerText: 'Estimated total',
  headerManualText: 'Total',
  headerTextFree: 'Total',
  subHeaderText: 'We’ll authorise your card with £1.00.\nFull payment will be taken when your order is dispatched.',
  subHeaderManualText: 'This total has been calculated by the pharmacy.',
  buttonText: 'Place order',
};

const OrderPageContent = {
  authorisationText: BasketPageBarContent.subHeaderText
}

const OrderBarContent = {
  yourOrderText: 'Your order',
  basketText: 'Basket',
  confirmation: 'Confirmation',
};

const DashboardPageContent = {
  basicUserDashboard: {
      heading1: 'Booking a pharmacy service',
      heading2: 'Connecting your NHS account',
      subText1: 'If you would like to book a pharmacy service, please download and login to the Hey Pharmacist App.',
      subText2: 'Please download and login to the Hey Pharmacist App to connect your NHS account with Hey Pharmacist. This will allow you to order repeat prescriptions for collection from Rowlands Pharmacies.',
      subHeading1: 'Download the app here.',
      subHeading2: 'Click below to book a service via the website',
      subHeading3: 'Download the app to connect your NHS account',
      buttonText: 'Book a service',
  },
  medicationLoadingText: 'Loading your medications…',
  orderLoadingText: 'Loading your orders',
  missingMedicationText: 'Tell your GP something is missing',
  missingMedicationHeaderText: 'Medication missing?',
  missingMedicationIntroText:
    'Medication may not be listed because it’s not been put on repeat prescription by your GP.<br/><br/>If you think it should be, contact your GP.',
  linkedPatientText: 'Looking for your linked profile?',
  linkedPatientHeaderText: 'Linked profiles',
  linkedPatientIntroText:
    'If you’ve linked a profile to this account then this isn’t available on the web right now, but you can order their medication through our mobile app.',
  requestMedicationText: 'Add and request the medication on your prescription',
  requestMedicationCTAText: 'Add medication',
};

const ConfirmGPPageContent = {
  gpHeadingText: 'Select your GP surgery',
  gpSubHeadingText: 'Confirm your GP surgery',
  confirmQuestionGPText: 'Confirm this GP',
  changeGPText: 'Change GP surgery',
};

const AddCardFormContent = {
  cardNumberTitleText: 'Card number',
  cardExpiryTitleText: 'Expiry date',
  cardExpiryTextPlaceholder: 'MM/YYYY',
  cardNameTitleText: 'Name on card',
  cardCVVTitleText: 'CVV',
  saveCardText: 'Add payment',
  displayCVVLinkText: 'What is CVV?',
  displayCVVTitleText: 'CVV',
  displayCVVIntroText:
    'The CVV Number ("Card Verification Value") on your credit card or debit card is the 3 digit number on the back of your card',
};

const BasketPageContent = {
  headingText: 'Request your order',
  offBoardingText: {
    heading: '',
    text: 'From {date}, this pharmacy will no longer be available on Hey Pharmacist. However, you can still collect from one of our other 4000 pharmacies or choose delivery. For more information, click ‘Learn More’.',
  },
};

const ManualOrderNotificationContent = {
  headerText: 'New order from GP',
  bodyText1: 'You have until ',
  bodyText2: ' to accept this order',
  bodyTextZeroDays: 'You have until the end of today to accept this order',
  buttonText: 'View',
};

const ManualOrderPageContent = {
  headingText: 'Please confirm your order',
  acceptButtonText: 'Accept Order',
  rejectButtonText: 'Reject Order',
  helpHeader: 'See something wrong?',
  helpText: 'Help & Support',
  informationHeader: 'Awaiting Payment',
  informationText: 'Your GP has placed a new order, please make payment to receive your medication.',
};

const RejectOrderOverlayContent = {
  headingText: 'Are you sure you want to reject this order?',
  warningText:
    'By rejecting you will lose the progress of this order, but you can still go to another pharmacy to get your electronic prescriptions dispensed.',
};

const ManualBasketPageContent = {
  headingText: 'Request your order',
  deliveryHeader: 'Delivery method',
  addressHeader: 'Delivery address',
  helpHeader: 'Need a different delivery address?',
  helpText: 'Help & Support',
  paymentHeader: 'Payment',
};

const NHSSettingsPageContent = {
  headingText: 'Your NHS login settings',
  subHeadingText:
    'View and update settings for NHS login using the link below.',
  warningHeadingText: 'Before updating your NHS settings',
  warningSubHeadingText:
    'We strongly advise you change your details in the Hey Pharmacist app first, otherwise you will not be able to login to Hey Pharmacist.',
  ctaText: 'Hey Pharmacist app is available from the Apple App Store and Google Play Store.',
  loginText: 'Go to NHS login settings',
};

const NHSLoginErrorPageContent = {
  headingText: "Consent Not Given",
  bodyText: "You did not agree to share your NHS login information with us. We need this to complete your account. Tap 'Register using NHS login' again and click 'I agree' at the end of the process.",
  ctaText: "Register"
}

const FooterContent = [
  {
    href: "/about-us",
    "data-linktext": "About Hey Pharmacist"
  },
  {
    href: "/privacypolicy",
    "data-contentparent": "Legal",
    "data-linktext": "Privacy policy"
  },
  {
    href: "/cookie-policy",
    "data-contentparent": "Legal",
    "data-linktext": "Cookies"
  },
  {
    href: "/terms-and-conditions",
    "data-contentparent": "Legal",
    "data-linktext": "Terms and Conditions"
  },
  {
    href: "/governance-and-compliance",
    "data-contentparent": "Legal",
    "data-linktext": "Governance and Compliance"
  },
  {
    href: "/freedom-of-information",
    "data-contentparent": "Legal",
    "data-linktext": "Freedom of Information"
  },
  {
    href: "https://intercom-help.eu/heypharmacist/en/articles/27551-responsible-pharmacist",
    "data-contentparent": "Legal",
    "data-linktext": "Responsible Pharmacist"
  },
]

const AccountPageContent = {
  modal: {
    headerText: "Page not available",
    subHeadingText1: "This page is only available when you connect your NHS account",
    buttonText: "Close"
  }
}

const NHSLogoText = {
  continue: 'Continue to NHS login',
  signIn: 'Sign in with NHS login',
  register: 'Register with NHS login'
}

const OrderItemStatusContent = {
  header: "What do the status's mean?",
  statuses: [
    {
      status: 'Requested',
      description: 'Your request for medication has been securely sent to your GP to check.'
    },
    {
      status: 'Processed',
      description: "Your request has been processed by the GP, we will let you know if we receive the prescription and start preparing your order."
    },
    {
      status: "Issued",
      description: "Your request has been approved by the GP. We’ll let you know when we receive your prescription and start preparing your order."
    },
    {
      status: "Rejected",
      description: "Your GP has not authorised your request for medication - contact them to find out why."
    },
    {
      status: "Added",
      description: "An item has been added to your order."
    },
    {
      status: "Removed",
      description: "We have not yet received your medication, as it awaits approval from your GP, or we have not received the prescription from your GP. Alternatively, it may have been combined with another order."
    }
  ],
  subHeader: "Why we combine orders?",
  paragraphText1: "Instead of receiving multiple deliveries at different times, you will get one consolidated delivery, which is more convenient.",
  cta: {
    link:  "https://intercom-help.eu/heypharmacist/en",
    text: 'For more help, contact our customer experience team'
  }
}

export {
  OrderItemStatusContent,
  NHSLogoText,
  AddMedicationPageContent,
  AddMedicationSelectPageContent,
  AddMedicationFormContent,
  RegisterPageContent,
  RegisterContinuePageContent,
  ConsentPageContent,
  LoginPageContent,
  LoginMobilePageContent,
  LoginEmailPageContent,
  SignInMobileFormContent,
  SignInEmailFormContent,
  LogoutPageContent,
  ErrorPageContent,
  RedirectPageContent,
  BasketBarContent,
  DashboardPageContent,
  OrderBarContent,
  DeliveryOptionPageContent,
  DeliveryDetailsPageContent,
  PharmacyDeliveryPageContent,
  PaymentMethodPageContent,
  AddCardFormContent,
  BasketPageContent,
  BasketPageBarContent,
  OrderPageContent,
  EmailPreferencePageContent,
  ConfirmGPPageContent,
  ManualOrderNotificationContent,
  ManualOrderPageContent,
  ManualBasketPageContent,
  RejectOrderOverlayContent,
  NHSSettingsPageContent,
  NHSLoginErrorPageContent,
  FooterContent,
  AccountPageContent,
};
